/* eslint-disable */
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../services/Axios/axios";
import RenderITOfficerPage from "../RenderITOfficerPage";
import UploadCard from "../components/UploadCard";

function UploadMart() {
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState(null);

  const handleUpload = async (file) => {
    setIsLoading(true);
    setResponse(null);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await axiosInstance.post("/loans/upload-mart-deduction", formData);
      setResponse({ state: "SUCCESS", message: "Mart deductions uploaded successfully. Processing in background." });
      toast.success("Mart deductions uploaded successfully");
    } catch (e) {
      const msg = e?.response?.data?.message ?? "Upload failed. Try again.";
      setResponse({ state: "ERROR", message: msg });
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <RenderITOfficerPage title="Upload Mart Deductions">
      <UploadCard
        title="Upload Mart Deductions"
        description="Upload an Excel or CSV file containing mart deduction records."
        onUpload={handleUpload}
        isLoading={isLoading}
        response={response}
        accentColor="emerald"
      />
      <ToastContainer autoClose={3000} />
    </RenderITOfficerPage>
  );
}

export default UploadMart;
